import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlockSearchResultsAllComponent, CardType, CONFIG } from '@gallaghercp/core-frontend';
import { Observable, of } from 'rxjs';
import { APP_CONFIG } from '../../app.config';

@Component({
    selector: 'core-block-search-results',
    templateUrl: './block-search-results-all.component.html',
    styleUrls: ['./block-search-results-all.component.scss'],
    standalone: false,
})
export class BlockClientSearchResultsAllComponent extends BlockSearchResultsAllComponent implements OnInit, OnDestroy {
    currentZone = '';
    pages$!: Observable<any>;
    allPages: any[] = [];
    isListFormat = (APP_CONFIG as CONFIG).search?.searchResultsInListFormat ?? false;

    override ngOnInit() {
        super.ngOnInit();

        const currentZoneNumber = Number.parseInt(this.api.getServiceZone());
        // Use app.config zoneRouting mapping to resolve current zone route by id
        const zoneRouting = ((APP_CONFIG as any).zoneRouting ?? []) as any[];
        const matched = zoneRouting.find((z: any) => z && z.id === currentZoneNumber);
        if (matched && matched.route) {
            this.currentZone = String(matched.route);
        }

        this.subscriptions.push(
            this.pages!.getAll().subscribe((pages: any) => {
                this.pages$ = of(pages);
                this.allPages = pages;
            }),
        );
    }

    // Get URL of parent
    parentUrl(card: CardType) {
        const foundParent = this.allPages.find((page: { id: number | undefined }) => page.id === card.parentId);
        return foundParent ? foundParent.url : this.currentZone;
    }
}
